import React from 'react';
import { Link } from 'react-router-dom';

// ───────── Base icon primitive (lucide-style stroke SVGs) ─────────
export const Icon = ({ children, size = 20, stroke = 'currentColor', fill = 'none', style, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={stroke}
    strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0, ...style }} {...rest}>
    {children}
  </svg>
);

export const I = {
  Home: p => <Icon {...p}><path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V9.5z"/></Icon>,
  Stats: p => <Icon {...p}><path d="M3 3v18h18"/><path d="M7 15l3-5 4 3 5-8"/></Icon>,
  Cash: p => <Icon {...p}><rect x="2" y="6" width="20" height="13" rx="2"/><circle cx="12" cy="12.5" r="2.5"/><path d="M6 10v5M18 10v5"/></Icon>,
  User: p => <Icon {...p}><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></Icon>,
  Book: p => <Icon {...p}><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v18H6.5A2.5 2.5 0 0 0 4 22.5V4.5z"/><path d="M8 6h8M8 10h8M8 14h5"/></Icon>,
  Shield: p => <Icon {...p}><path d="M12 2l8 3v7c0 5-3.5 9-8 10-4.5-1-8-5-8-10V5l8-3z"/></Icon>,
  Sword: p => <Icon {...p}><path d="M14.5 17.5L3 6V3h3l11.5 11.5"/><path d="M13 19l6-6"/><path d="M16 16l4 4"/><path d="M19 21l2-2"/></Icon>,
  Diamond: p => <Icon {...p}><path d="M6 3h12l3 5-9 12L3 8z"/><path d="M11 3L8 8h8L13 3"/><path d="M3 8h18"/></Icon>,
  Flame: p => <Icon {...p}><path d="M8.5 14.5A3 3 0 1 0 15 13c-.4-1-1.5-2-1.5-3.5 0-1-1-2-3-2.5 0 2-2 3-2 5.5 0 .8.3 1.5.5 2z"/><path d="M12 2c1 2 3 3 3 6-2-1-3-2-3-6z"/></Icon>,
  Chevron: p => <Icon {...p}><path d="M9 6l6 6-6 6"/></Icon>,
  ChevronDown: p => <Icon {...p}><path d="M6 9l6 6 6-6"/></Icon>,
  Back: p => <Icon {...p}><path d="M15 6l-6 6 6 6"/></Icon>,
  Bell: p => <Icon {...p}><path d="M18 16l-1-1V11a5 5 0 0 0-10 0v4l-1 1h12z"/><path d="M10 19a2 2 0 0 0 4 0"/></Icon>,
  Trophy: p => <Icon {...p}><path d="M8 4h8v4a4 4 0 0 1-8 0V4z"/><path d="M5 4H2v3a3 3 0 0 0 3 3M19 4h3v3a3 3 0 0 1-3 3"/><path d="M10 14h4M9 20h6M12 14v6"/></Icon>,
  Clock: p => <Icon {...p}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></Icon>,
  Sparkle: p => <Icon {...p}><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z"/></Icon>,
  Check: p => <Icon {...p}><path d="M4 12l5 5L20 6"/></Icon>,
  X: p => <Icon {...p}><path d="M6 6l12 12M18 6L6 18"/></Icon>,
  Plus: p => <Icon {...p}><path d="M12 5v14M5 12h14"/></Icon>,
  Info: p => <Icon {...p}><circle cx="12" cy="12" r="9"/><path d="M12 8v.01M11 12h1v4h1"/></Icon>,
  Alert: p => <Icon {...p}><path d="M12 3l10 18H2L12 3z"/><path d="M12 10v4M12 18v.01"/></Icon>,
  Eye: p => <Icon {...p}><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></Icon>,
  Globe: p => <Icon {...p}><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18"/></Icon>,
  Logout: p => <Icon {...p}><path d="M15 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4"/><path d="M10 17l-5-5 5-5M5 12h12"/></Icon>,
  Copy: p => <Icon {...p}><rect x="8" y="8" width="13" height="13" rx="2"/><path d="M16 8V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h4"/></Icon>,
  Gift: p => <Icon {...p}><path d="M20 12v9H4v-9"/><rect x="2" y="7" width="20" height="5" rx="1"/><path d="M12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5c2 0 4.5 3 4.5 5M12 7h4.5a2.5 2.5 0 0 0 0-5c-2 0-4.5 3-4.5 5"/></Icon>,
  Send: p => <Icon {...p}><path d="M21 3L3 11l7 3 3 7 8-18z"/><path d="M21 3l-11 11"/></Icon>,
  Link: p => <Icon {...p}><path d="M10 14a4 4 0 0 0 5.6 0l3-3a4 4 0 0 0-5.6-5.6L11 7"/><path d="M14 10a4 4 0 0 0-5.6 0l-3 3a4 4 0 0 0 5.6 5.6L13 17"/></Icon>,
  Calendar: p => <Icon {...p}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/></Icon>,
  TrendUp: p => <Icon {...p}><path d="M3 17l6-6 4 4 8-8"/><path d="M14 7h7v7"/></Icon>,
  TrendDown: p => <Icon {...p}><path d="M3 7l6 6 4-4 8 8"/><path d="M14 17h7v-7"/></Icon>,
  Tiktok: p => <Icon {...p}><path d="M12 3v13a4 4 0 1 1-4-4"/><path d="M12 3c0 3 2 5 5 5"/></Icon>,
  Settings: p => <Icon {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></Icon>,
};

// ───────── Tier Badge ─────────
export function TierBadge({ tier = 3, size = 'md' }) {
  const palette = {
    1: ['#8B8B95', '#3A3A42'],
    2: ['#C2C2C9', '#6B6B75'],
    3: ['#FCD34D', '#B45309'],
    4: ['#E5E4E2', '#8A8A95'],
    5: ['#FDE68A', '#B45309'],
    6: ['#F472B6', '#7E1D47'],
    7: ['#A78BFA', '#3B1D7E'],
    8: ['#22D3EE', '#0A5567'],
  };
  const [a, b] = palette[tier] || palette[3];
  const px = size === 'sm' ? 22 : size === 'lg' ? 52 : 32;
  return (
    <div style={{
      width: px, height: px, borderRadius: '50%',
      background: `conic-gradient(from 180deg, ${a}, ${b}, ${a})`,
      display: 'grid', placeItems: 'center',
      fontFamily: 'var(--font-mono)', fontWeight: 700,
      fontSize: px * 0.42, color: '#0A0A0C',
      boxShadow: `0 0 20px ${a}44, inset 0 1px 0 rgba(255,255,255,0.4)`,
      border: '1.5px solid rgba(255,255,255,0.2)',
    }}>
      T{tier}
    </div>
  );
}

// ───────── Status pill ─────────
export function Pill({ children, color = 'neutral', style }) {
  const colors = {
    neutral: ['rgba(255,255,255,0.08)', 'var(--fg-1)'],
    pink: ['var(--accent-pink-soft)', 'var(--accent-pink)'],
    cyan: ['var(--accent-cyan-soft)', 'var(--accent-cyan)'],
    gold: ['var(--accent-gold-soft)', 'var(--accent-gold)'],
    green: ['var(--accent-green-soft)', 'var(--accent-green)'],
    red: ['var(--accent-red-soft)', 'var(--accent-red)'],
  };
  const [bg, fg] = colors[color] || colors.neutral;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '4px 10px', borderRadius: 999,
      background: bg, color: fg,
      fontSize: 12, fontWeight: 600, letterSpacing: 0.1,
      lineHeight: 1.2,
      ...style,
    }}>{children}</span>
  );
}

// ───────── Card ─────────
export function Card({ children, style, pad = 16, onClick }) {
  return (
    <div onClick={onClick} className={onClick ? 'tap' : ''} style={{
      background: 'var(--bg-2)',
      border: '1px solid var(--line-1)',
      borderRadius: 'var(--r-lg)',
      padding: pad,
      ...style,
    }}>{children}</div>
  );
}

// ───────── Progress Ring ─────────
export function Ring({ value = 0.65, size = 120, stroke = 10, color = 'var(--accent-pink)', trackColor = 'rgba(255,255,255,0.08)', children }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - Math.max(0, Math.min(1, value)));
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size/2} cy={size/2} r={r} stroke={trackColor} strokeWidth={stroke} fill="none"/>
        <circle cx={size/2} cy={size/2} r={r} stroke={color} strokeWidth={stroke} fill="none"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={off}
          style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(.2,.8,.2,1)', filter: `drop-shadow(0 0 6px ${color})` }}/>
      </svg>
      <div style={{
        position: 'absolute', inset: 0,
        display: 'grid', placeItems: 'center',
      }}>{children}</div>
    </div>
  );
}

// ───────── Diamond gem (filled) ─────────
export function DiamondGem({ size = 18, color = 'var(--accent-cyan)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ filter: `drop-shadow(0 0 4px ${color})` }}>
      <path d="M6 3h12l3 5-9 12L3 8l3-5z" fill={color} fillOpacity="0.25" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M11 3L8 8h8L13 3M3 8h18" stroke={color} strokeWidth="1.25" strokeLinejoin="round"/>
    </svg>
  );
}

// ───────── Screen header ─────────
export function ScreenHeader({ title, subtitle, right, onBack }) {
  return (
    <div style={{
      padding: '48px 20px 16px',
      display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
      gap: 12,
    }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        {onBack && (
          <div className="tap" onClick={onBack} style={{
            width: 36, height: 36, borderRadius: 12,
            background: 'var(--bg-3)', display: 'grid', placeItems: 'center',
            marginBottom: 12,
          }}>
            <I.Back size={18} stroke="var(--fg-1)"/>
          </div>
        )}
        {subtitle && <div style={{
          fontSize: 13, fontWeight: 500, color: 'var(--fg-2)',
          letterSpacing: 0.2, textTransform: 'uppercase', marginBottom: 6,
        }}>{subtitle}</div>}
        <div style={{
          fontSize: 28, fontWeight: 700, letterSpacing: -0.6,
          color: 'var(--fg-0)', lineHeight: 1.1,
        }}>{title}</div>
      </div>
      {right}
    </div>
  );
}

// ───────── Section label ─────────
export function SectionLabel({ children, right }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      marginBottom: 10, padding: '0 2px',
    }}>
      <div style={{ fontSize: 10, color: 'var(--fg-3)', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase' }}>{children}</div>
      {right}
    </div>
  );
}

// ───────── Stat tile ─────────
export function StatTile({ label, value, sub, icon }) {
  return (
    <div style={{
      background: 'var(--bg-2)',
      border: '1px solid var(--line-1)',
      borderRadius: 16, padding: 12,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 4 }}>
        {icon}
        <span style={{ fontSize: 10, color: 'var(--fg-3)', fontWeight: 600, letterSpacing: 0.3, textTransform: 'uppercase' }}>
          {label}
        </span>
      </div>
      <div className="mono tab" style={{ fontSize: 22, fontWeight: 700, color: 'var(--fg-0)', letterSpacing: -0.8, lineHeight: 1 }}>
        {value}{sub && <span style={{ fontSize: 11, color: 'var(--fg-3)', fontWeight: 500, marginLeft: 2 }}>{sub}</span>}
      </div>
    </div>
  );
}

// ───────── Quick link ─────────
export function QuickLink({ icon, title, desc, onClick, tint = 'pink', span = 1 }) {
  return (
    <div className="tap" onClick={onClick} style={{
      gridColumn: span === 2 ? 'span 2' : 'auto',
      background: 'var(--bg-2)',
      border: '1px solid var(--line-1)',
      borderRadius: 16, padding: 14,
      display: 'flex', alignItems: 'center', gap: 12,
    }}>
      <div style={{
        width: 36, height: 36, borderRadius: 10,
        background: `var(--accent-${tint}-soft)`,
        border: `1px solid oklch(from var(--accent-${tint}) l c h / 0.25)`,
        display: 'grid', placeItems: 'center',
      }}>{icon}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--fg-0)' }}>{title}</div>
        {desc && <div style={{ fontSize: 11, color: 'var(--fg-3)', marginTop: 1 }}>{desc}</div>}
      </div>
      <I.Chevron size={14} stroke="var(--fg-3)"/>
    </div>
  );
}

// ───────── Bottom nav (floating pill) ─────────
export function BottomNav({ active = 'dashboard', qs = '', variant = 'agency' }) {
  const tabs = variant === 'public'
    ? [
        { id: 'public-dashboard', to: `/my/public-dashboard${qs}`, label: 'Home', Icon: I.Home },
        { id: 'calculator', to: `/my/calculator${qs}`, label: 'Calculator', Icon: I.Diamond },
        { id: 'agency-stats', to: `/my/agency-stats${qs}`, label: 'Agency', Icon: I.Trophy },
        { id: 'apply', to: `/my/apply${qs}`, label: 'Join', Icon: I.Sparkle },
      ]
    : [
        { id: 'dashboard', to: `/my/dashboard${qs}`, label: 'Home', Icon: I.Home },
        { id: 'stats', to: `/my/stats${qs}`, label: 'Stats', Icon: I.Stats },
        { id: 'cashback', to: `/my/cashback${qs}`, label: 'Cashback', Icon: I.Cash },
        { id: 'profile', to: `/my/profile${qs}`, label: 'Profile', Icon: I.User },
      ];
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      padding: '8px 12px 22px',
      background: 'linear-gradient(to top, rgba(10,10,12,0.96) 60%, rgba(10,10,12,0))',
      backdropFilter: 'blur(20px)',
      zIndex: 40,
      pointerEvents: 'none',
    }}>
      <div style={{
        background: 'rgba(28,28,34,0.85)',
        border: '1px solid var(--line-2)',
        borderRadius: 999,
        padding: 6,
        display: 'flex', gap: 2,
        boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
        maxWidth: 420, margin: '0 auto',
        pointerEvents: 'auto',
      }}>
        {tabs.map(t => {
          const is = active === t.id;
          const Inner = (
            <div style={{
              flex: 1, padding: '10px 6px', borderRadius: 999,
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
              background: is ? 'var(--bg-4)' : 'transparent',
              color: is ? 'var(--fg-0)' : 'var(--fg-3)',
              transition: 'all 0.2s',
              fontSize: 10, fontWeight: 600, letterSpacing: 0.2,
              textDecoration: 'none',
            }}>
              <t.Icon size={20} stroke="currentColor"/>
              <span>{t.label}</span>
            </div>
          );
          return is
            ? <div key={t.id} style={{ flex: 1 }}>{Inner}</div>
            : <Link key={t.id} to={t.to} style={{ flex: 1, textDecoration: 'none' }}>{Inner}</Link>;
        })}
      </div>
    </div>
  );
}

// ───────── Placeholder (dashed) ─────────
export function Placeholder({ label, height = 120, style }) {
  return (
    <div style={{
      height,
      borderRadius: 'var(--r-md)',
      background: `repeating-linear-gradient(135deg,
        rgba(255,255,255,0.02) 0 10px,
        rgba(255,255,255,0.04) 10px 20px)`,
      border: '1px dashed var(--line-2)',
      display: 'grid', placeItems: 'center',
      fontFamily: 'var(--font-mono)',
      fontSize: 11, color: 'var(--fg-3)',
      letterSpacing: 0.5,
      ...style,
    }}>{label}</div>
  );
}

// ───────── Screen wrapper with creator-scope class ─────────
export function CreatorScreen({ children, style, className = '' }) {
  return (
    <div className={`creator-scope ${className}`} style={{ minHeight: '100dvh', background: 'var(--bg-0)', ...style }}>
      {children}
    </div>
  );
}
